import { useContext } from "react";
import { AppTimezoneContext } from "./TimezoneProvider";

export const useAppTimezone = () => {
    return useContext(AppTimezoneContext);
};
